<div class="desktop-landing">
  <div class="overlay"></div>

  <div class="content">
    <div class="desktop-header">
      <div class="logo">
        <img [src]="getLogoPath()" alt="">
      </div>
      <div class="skip-qr-page">
        <round-button [label]="'Estoy usando un móvil, continuar igualmente'" (click)="goToLogin()" class="button-primary"></round-button>
      </div>
    </div>
    <div class="card">
      <div class="card-left">
        <div class="text-block">
          <p class="title">
            This site is designed to be used<br />
            on your mobile phone. Scan the QR<br />
            code with your smartphone to<br />
            access it.
          </p>

          <div class="qr-wrapper">
            <qrcode [qrdata]="getQrPath()" [width]="150"></qrcode>
          </div>

          <p class="subtitle">
            Este sitio está diseñado para ser<br />
            usado en tu teléfono móvil.<br />
            Escanea el código QR con tu<br />
            smartphone para acceder.
          </p>
        </div>
      </div>

      <div class="phone-wrapper">
        <img src="/images/desktop-hand-mobile.png" alt="" />
      </div>
    </div>

    <!-- Powered by / pie -->
    <div class="powered-by">
      <hv-logo></hv-logo>
    </div>
  </div>
</div>
